import React, { useState, useMemo, useEffect } from "react";

import I from "../component/Icon";

import CenterForm from "../component/CenterForm";

import CenterView from "../component/CenterView";

import ConfirmDlg from "../component/ConfirmDialog";

import Bdg from "../component/Badge";

import SB from "../component/SearchBox";

import apiService from "../services/apiService";

const ITEMS_PER_PAGE = 10;

const showNotification = (type, message) => {

  if (

    typeof document === "undefined" ||

    typeof window === "undefined"

  ) {

    return;

  }

  const existingNotification =

    document.getElementById(

      "centers-page-notification"

    );

  if (existingNotification) {

    existingNotification.remove();

  }

  const notification =

    document.createElement("div");

  notification.id =

    "centers-page-notification";

  notification.textContent =

    `${type === "success" ? "✓" : "✕"} ${message}`;

  Object.assign(

    notification.style,

    {

      position: "fixed",

      top: "20px",

      right: "20px",

      zIndex: "99999",

      minWidth: "280px",

      maxWidth: "420px",

      padding: "12px 16px",

      borderRadius: "8px",

      backgroundColor:

        type === "success"

          ? "#d1e7dd"

          : "#f8d7da",

      color:

        type === "success"

          ? "#0f5132"

          : "#842029",

      border:

        type === "success"

          ? "1px solid #badbcc"

          : "1px solid #f5c2c7",

      fontSize: "14px",

      fontWeight: "600",

      boxShadow:

        "0 4px 12px rgba(0,0,0,0.15)",

    }

  );

  document.body.appendChild(notification);

  window.setTimeout(() => {

    if (notification.parentNode) {

      notification.remove();

    }

  }, 3000);

};

const getErrorMessage = (error, fallback) => {

  const data = error?.response?.data;

  if (

    typeof data === "string" &&

    data.trim()

  ) {

    return data;

  }

  if (

    data &&

    typeof data === "object"

  ) {

    if (

      data?.errors &&

      typeof data.errors === "object"

    ) {

      const validationMessage =

        Object.entries(data.errors)

          .flatMap(([key, value]) => {

            const messages =

              Array.isArray(value)

                ? value

                : [value];

            return messages.map(

              (message) =>

                `${key}: ${message}`

            );

          })

          .filter(Boolean)

          .join(" ");

      if (validationMessage) {

        return validationMessage;

      }

    }

    return (

      data?.failureReason ||

      data?.FailureReason ||

      data?.message ||

      data?.Message ||

      data?.title ||

      error?.message ||

      fallback

    );

  }

  return (

    error?.message ||

    fallback

  );

};

export default function CentersPage({

  centers,

  setCenters,

}) {

  const [sub, setSub] = useState("list");

  const [view, setView] = useState(null);

  const [edit, setEdit] = useState(null);

  const [del, setDel] = useState(null);

  const [q, setQ] = useState("");

  const [cf, setCf] = useState("All");

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const fetchAllCenters = async () => {

    try {

      setLoading(true);

      setError("");

      const [

        centerRes,

        talukaRes,

        capacityRes,

      ] = await Promise.all([

        apiService.get(

          "Center/getAllCenter"

        ),

        apiService.get(

          "TalukaMaster/getAllTalukaMasters"

        ),

        apiService.get(

          "Capacity/getAllCapacity"

        ),

      ]);

      const centerData =

        centerRes?.data;

      const talukaData =

        talukaRes?.data;

      const capacityData =

        capacityRes?.data;

      const centerList =

        centerData?.output ??

        centerData?.Output ??

        centerData?.data ??

        centerData?.Data ??

        [];

      const talukaList =

        talukaData?.output ??

        talukaData?.Output ??

        talukaData?.data ??

        talukaData?.Data ??

        [];

      const capacityList =

        capacityData?.output ??

        capacityData?.Output ??

        capacityData?.data ??

        capacityData?.Data ??

        [];

      const talukaMap =

        Object.fromEntries(

          (

            Array.isArray(talukaList)

              ? talukaList

              : []

          ).map((t) => [

            t?.id ?? t?.Id,

            t?.talukaName ??

              t?.TalukaName ??

              "",

          ])

        );

      const capacityMap =

        Object.fromEntries(

          (

            Array.isArray(capacityList)

              ? capacityList

              : []

          ).map((c) => {

            const id =

              c?.id ?? c?.Id;

            const name =

              c?.name ??

              c?.Name ??

              "";

            return [

              id,

              {

                name,

                value:

                  Number(

                    String(name)

                      .split("-")[1]

                  ) || 0,

              },

            ];

          })

        );

      const mappedCenters =

        (

          Array.isArray(centerList)

            ? centerList

            : []

        ).map((c) => {

          const talukaId =

            c?.talukaId ??

            c?.TalukaId;

          const capacityId =

            c?.capacityId ??

            c?.CapacityId;

          return {

            ...c,

            id:

              c?.id ??

              c?.Id,

            name:

              c?.name ??

              c?.Name ??

              "",

            talukaId,

            capacityId,

            city:

              talukaMap[talukaId] ||

              "",

            capacity:

              capacityMap[capacityId]

                ?.name ||

              "",

            capacityValue:

              capacityMap[capacityId]

                ?.value ||

              0,

            assigned:

              c?.assigned ??

              c?.Assigned ??

              0,

          };

        });

      setCenters(mappedCenters);

    } catch (err) {

      console.error(

        "Error fetching centers:",

        err

      );

      const message =

        getErrorMessage(

          err,

          "Unable to load centers. Please try again."

        );

      setError(message);

      showNotification(

        "error",

        message

      );

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {

    fetchAllCenters();

  }, [setCenters]);

  const ws = useMemo(() => {

    return centers.map((c) => ({

      ...c,

      pct: c.capacityValue

        ? Math.round((c.assigned / c.capacityValue) * 100)

        : 0,

      st:

        c.assigned >= c.capacityValue

          ? "full"

          : c.capacityValue &&

              c.assigned / c.capacityValue > 0.8

            ? "high"

            : "ok",

    }));

  }, [centers]);

  const filtered = useMemo(() => {

    return ws.filter(

      (c) =>

        [c.name, c.city]

          .join(" ")

          .toLowerCase()

          .includes(q.toLowerCase()) &&

        (

          cf === "All" ||

          (cf === "Full" && c.st === "full") ||

          (cf === "High" && c.st === "high") ||

          (cf === "Available" && c.st === "ok")

        )

    );

  }, [ws, q, cf]);

  const totalPages = Math.max(

    1,

    Math.ceil(filtered.length / ITEMS_PER_PAGE)

  );

  useEffect(() => {

    if (currentPage > totalPages) {

      setCurrentPage(totalPages);

    }

  }, [currentPage, totalPages]);

  useEffect(() => {

    setCurrentPage(1);

  }, [q, cf]);

  const pageNumbers = Array.from(

    { length: totalPages },

    (_, index) => index + 1

  );

  const paginatedCenters = filtered.slice(

    (currentPage - 1) * ITEMS_PER_PAGE,

    currentPage * ITEMS_PER_PAGE

  );

  const showingFrom =

    filtered.length === 0

      ? 0

      : (currentPage - 1) * ITEMS_PER_PAGE + 1;

  const showingTo =

    filtered.length === 0

      ? 0

      : Math.min(

          currentPage * ITEMS_PER_PAGE,

          filtered.length

        );

  const doDelete = async () => {

    console.log(

      "DELETE BUTTON CLICKED"

    );

    console.log(

      "Selected center:",

      del

    );

    if (!del) return;

    try {

      const centerId =

        del?.id ??

        del?.Id;

      if (!centerId) {

        throw new Error(

          "Center ID is missing."

        );

      }

      const response =

        await apiService.delete(

          `Center/deleteCenter/${centerId}`

        );

      const responseData =

        response?.data;

      console.log(

        "DELETE RESPONSE:",

        responseData

      );

      if (

        responseData &&

        typeof responseData ===

          "object" &&

        (

          responseData?.isSuccess ===

            false ||

          responseData?.IsSuccess ===

            false

        )

      ) {

        throw new Error(

          responseData?.failureReason ||

          responseData?.FailureReason ||

          responseData?.message ||

          responseData?.Message ||

          "Failed to delete center"

        );

      }

      setCenters((prev) =>

        prev.filter(

          (center) =>

            Number(

              center?.id ??

                center?.Id

            ) !==

            Number(centerId)

        )

      );

      showNotification(

        "success",

        "Center deleted successfully!"

      );

      setDel(null);

    } catch (error) {

      console.error(

        "Error deleting center:",

        error

      );

      showNotification(

        "error",

        getErrorMessage(

          error,

          "Unable to delete center"

        )

      );

    }

  };

  const doSave = async (data) => {

    try {

      await fetchAllCenters();

      showNotification(

        "success",

        data?._isEdit

          ? "Center updated successfully!"

          : "Center added successfully!"

      );

      setSub("list");

      setEdit(null);

      setCurrentPage(1);

    } catch (error) {

      console.error(

        "Center save refresh error:",

        error

      );

      showNotification(

        "error",

        getErrorMessage(

          error,

          data?._isEdit

            ? "Unable to update center"

            : "Unable to add center"

        )

      );

    }

  };

  if (loading) {

    return (

      <div

        className="card"

        style={{

          padding: "30px",

          textAlign: "center",

        }}

      >

        Loading centers...

      </div>

    );

  }

  if (error) {

    return (

      <div

        className="card"

        style={{

          padding: "30px",

          textAlign: "center",

        }}

      >

        <div

          style={{

            color: "#dc2626",

            marginBottom: "15px",

          }}

        >

          {error}

        </div>

        <button

          className="btn btn-p"

          onClick={fetchAllCenters}

        >

          Retry

        </button>

      </div>

    );

  }

  if (sub === "add") {

    return (

      <CenterForm

        title="Add Center"

        onSave={doSave}

        onBack={() => setSub("list")}

      />

    );

  }

  if (sub === "edit" && edit) {

    return (

      <CenterForm

        title="Edit Center"

        initial={edit}

        onSave={doSave}

        onBack={() => {

          setSub("list");

          setEdit(null);

        }}

      />

    );

  }

  if (sub === "view" && view) {

    return (

      <CenterView

        center={

          ws.find((c) => c.id === view.id) || view

        }

        onBack={() => {

          setSub("list");

          setView(null);

        }}

        onEdit={(c) => {

          setEdit(c);

          setSub("edit");

        }}

      />

    );

  }

  return (

    <>
      <style>{`
        .centers-responsive-page { min-width: 0; max-width: 100%; overflow-x: hidden; }
        .centers-responsive-page.card { min-width: 0; max-width: 100%; }
        .centers-responsive-page .tw { max-width: 100%; overflow-x: auto; }
        .centers-responsive-page .centers-pagination-footer {
          box-sizing: border-box; width: 100% !important; max-width: 100% !important;
          min-width: 0 !important; display: flex !important; flex-direction: row !important;
          flex-wrap: nowrap !important; justify-content: space-between !important;
          align-items: center !important; gap: 8px !important; overflow: hidden !important;
        }
        .centers-responsive-page .centers-pagination-count {
          flex: 0 0 auto !important; white-space: nowrap !important;
        }
        .centers-responsive-page .centers-pagination-bar {
          display: flex !important; align-items: center !important;
          flex: 1 1 0 !important; min-width: 0 !important;
          max-width: 100% !important; width: auto !important;
          flex-wrap: nowrap !important; justify-content: flex-end !important;
          overflow: hidden !important; gap: 5px !important;
        }
        .centers-responsive-page .centers-pagination-bar > button {
          flex: 0 0 auto !important; white-space: nowrap !important;
        }
        .centers-responsive-page .centers-pagination-numbers {
          display: flex !important; align-items: center !important;
          flex: 0 1 auto !important; min-width: 0 !important;
          max-width: 100% !important; flex-wrap: nowrap !important;
          overflow-x: auto !important; overflow-y: hidden !important;
          scrollbar-width: thin; -webkit-overflow-scrolling: touch;
          overscroll-behavior-x: contain;
        }
        .centers-responsive-page .centers-pagination-numbers > button {
          flex: 0 0 auto !important;
        }
        @media (max-width: 650px) {
          .centers-responsive-page .centers-pagination-footer { gap: 5px !important; }
          .centers-responsive-page .centers-pagination-count { font-size: 9px !important; }
          .centers-responsive-page .centers-pagination-bar { gap: 3px !important; }
          .centers-responsive-page .centers-pagination-bar > button {
            min-width: 42px !important; padding: 0 4px !important; font-size: 9px !important;
          }
          .centers-responsive-page .centers-pagination-numbers { flex: 1 1 0 !important; }
          .centers-responsive-page .centers-pagination-numbers > button {
            min-width: 28px !important; padding: 0 5px !important;
          }
        }
      `}</style>

      <div className="ph">

        <div className="ph-t">

          Centers Management

        </div>

      </div>

      <div className="toolbar">

        <SB

          value={q}

          onChange={setQ}

          placeholder="Search center, city…"

        />

       <button

  className="btn btn-p"

  onClick={() => {

    setEdit(null);

    setSub("add");

  }}

>

  <I n="plus" s={13} c="#fff" /> Add Center

</button>

      </div>

      <div className="card centers-responsive-page">

        <div className="tw">

          <table>

            <thead>

              <tr>

                <th>Center Name</th>

                <th>City</th>

                <th>Capacity</th>

                <th>Status</th>

                <th>Actions</th>

              </tr>

            </thead>

            <tbody>

              {paginatedCenters.map((c) => (

                <tr key={c.id}>

                  <td className="tdb">

                    {c.name}

                  </td>

                  <td className="td2">

                    {c.city}

                  </td>

                  <td>

                    {c.capacity}

                  </td>

                  <td>

                    {c.st === "full" ? (

                      <Bdg

                        type="red"

                        label="Full"

                      />

                    ) : c.st === "high" ? (

                      <Bdg

                        type="yellow"

                        label="High"

                      />

                    ) : (

                      <Bdg

                        type="green"

                        label="Available"

                      />

                    )}

                  </td>

                  <td>

                    <div className="ra">

                      <button

                        className="btn btn-p btn-sm"

                        onClick={() => {

                          setView(c);

                          setSub("view");

                        }}

                      >

                        <I

                          n="eye"

                          s={11}

                          c="#fff"

                        />

                      </button>

                      <button

                        className="btn btn-g btn-sm"

                        onClick={() => {

                          setEdit(c);

                          setSub("edit");

                        }}

                      >

                        <I

                          n="edit"

                          s={11}

                        />

                      </button>

                      <button

                        className="btn btn-d btn-sm"

                        onClick={() =>

                          setDel(c)

                        }

                      >

                        <I

                          n="trash"

                          s={11}

                        />

                      </button>

                    </div>

                  </td>

                </tr>

              ))}

              {filtered.length === 0 && (

                <tr>

                  <td

                    colSpan="5"

                    style={{

                      textAlign: "center",

                      padding: "30px",

                    }}

                  >

                    No centers found

                  </td>

                </tr>

              )}

            </tbody>

          </table>

        </div>

        {!loading && filtered.length > 0 && (

          <div className="centers-pagination-footer"

            style={{

              width: "100%",

              display: "flex",

              alignItems: "center",

              justifyContent: "space-between",

              gap: "16px",

              marginTop: "16px",

              padding: "12px 4px 4px",

              borderTop: "1px solid #eef2f7",

              flexWrap: "wrap",

            }}

          >

            <div className="centers-pagination-count"

              style={{

                display: "flex",

                alignItems: "center",

                whiteSpace: "nowrap",

                fontSize: "11px",

                lineHeight: "16px",

                color: "var(--t3)",

              }}

            >

              Showing{" "}

              <span

                style={{

                  margin: "0 4px",

                  fontWeight: 600,

                  color: "var(--t2)",

                }}

              >

                {showingFrom}

              </span>

              –

              <span

                style={{

                  margin: "0 4px",

                  fontWeight: 600,

                  color: "var(--t2)",

                }}

              >

                {showingTo}

              </span>

              {" "}of{" "}

              <span

                style={{

                  marginLeft: "4px",

                  fontWeight: 600,

                  color: "var(--t2)",

                }}

              >

                {filtered.length}

              </span>

            </div>

            <div className="centers-pagination-bar"

              style={{

                display: "flex",

                alignItems: "center",

                gap: "5px",

                flexWrap: "wrap",

              }}

            >

              <button

                type="button"

                disabled={currentPage === 1}

                onClick={() =>

                  setCurrentPage((page) =>

                    Math.max(1, page - 1)

                  )

                }

                style={{

                  height: "32px",

                  minWidth: "66px",

                  padding: "0 10px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "3px",

                  border: "1px solid #e2e8f0",

                  borderRadius: "6px",

                  background:

                    currentPage === 1

                      ? "#f8fafc"

                      : "#fff",

                  color:

                    currentPage === 1

                      ? "#cbd5e1"

                      : "#475569",

                  fontSize: "11px",

                  fontWeight: 500,

                  cursor:

                    currentPage === 1

                      ? "not-allowed"

                      : "pointer",

                  transition: "all 0.15s ease",

                }}

              >

                <span

                  style={{

                    fontSize: "16px",

                    lineHeight: 1,

                  }}

                >

                  ‹

                </span>

                Back

              </button>

              <div className="centers-pagination-numbers"

                style={{

                  display: "flex",

                  alignItems: "center",

                  gap: "4px",

                  flexWrap: "wrap",

                }}

              >

                {pageNumbers.map((page) => (

                  <button

                    key={page}

                    type="button"

                    onClick={() =>

                      setCurrentPage(page)

                    }

                    style={{

                      height: "32px",

                      minWidth: "32px",

                      padding: "0 9px",

                      display: "inline-flex",

                      alignItems: "center",

                      justifyContent: "center",

                      border:

                        currentPage === page

                          ? "1px solid #2563eb"

                          : "1px solid #e2e8f0",

                      borderRadius: "6px",

                      background:

                        currentPage === page

                          ? "#2563eb"

                          : "#fff",

                      color:

                        currentPage === page

                          ? "#fff"

                          : "#475569",

                      fontSize: "11px",

                      fontWeight: 600,

                      cursor: "pointer",

                      transition: "all 0.15s ease",

                    }}

                  >

                    {page}

                  </button>

                ))}

              </div>

              <button

                type="button"

                disabled={

                  currentPage >= totalPages

                }

                onClick={() =>

                  setCurrentPage((page) =>

                    Math.min(

                      totalPages,

                      page + 1

                    )

                  )

                }

                style={{

                  height: "32px",

                  minWidth: "66px",

                  padding: "0 10px",

                  display: "inline-flex",

                  alignItems: "center",

                  justifyContent: "center",

                  gap: "3px",

                  border: "1px solid #e2e8f0",

                  borderRadius: "6px",

                  background:

                    currentPage >= totalPages

                      ? "#f8fafc"

                      : "#fff",

                  color:

                    currentPage >= totalPages

                      ? "#cbd5e1"

                      : "#475569",

                  fontSize: "11px",

                  fontWeight: 500,

                  cursor:

                    currentPage >= totalPages

                      ? "not-allowed"

                      : "pointer",

                  transition: "all 0.15s ease",

                }}

              >

                Next

                <span

                  style={{

                    fontSize: "16px",

                    lineHeight: 1,

                  }}

                >

                  ›

                </span>

              </button>

            </div>

          </div>

        )}

      </div>

      {del && (

        <ConfirmDlg

          title="Delete Center"

          msg={`Delete "${del.name}"?`}

          onOk={doDelete}

          onCancel={() => setDel(null)}

        />

      )}

    </>

  );

}